import { CircularProgress, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getClientes, getContadoresTareasProyectos, getOpcionesProyectos, getProyectos, verificarToken } from '../../services/apis';

import { ProyectoCard } from './ProyectoCard';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import { OpcionesMenuFunc } from '../../utils/componentes-utiles/OpcionesMenuFunc';
import { FormCrearProyecto } from './FormCrearProyecto';
import { ordenarPorCampoTexto } from '../../utils/utils';

//mapa de iconos


export const Proyectos = () => {
    // Estados auxiliares
    const [loaded, setLoaded] = useState(false);

    // Estados útiles
    const [clientes, setClientes] = useState([]);
    const [proyectos, setProyecto] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [proyectosCopia, setProyectosCopia] = useState([]);
    const [opcionesEdit, setOpcionesEdit] = useState([]);
    const [open, setOpen] = useState(false);
    const [opcionesDialog, setOpcionesDialog] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [rolUsuario, setRolUsuario] = useState(null);
    const [resumenTareasGlobal, setResumenTareasGlobal] = useState(null);
    const [resumenProyectos, setResumenProyectos] = useState({
        activos: 0,
        ocultos: 0
    });
    // Cargar opciones menú principal


    const colorEstado = (color) => {
        if (!color) return '#999999';
        return color.startsWith('#') ? color : `#${color}`;
    };

    const nombreEstadoResumen = (nombre) => {
        return nombre?.toLowerCase() === 'en espera' ? 'Sin iniciar' : nombre;
    };

    const estadosConSinAsignarGlobal = (contador) => {
        const estados = contador?.estados || [];

        const contadorSinAsignar = {
            id_estado: 'sin_asignar',
            nombre: 'Sin asignar',
            color: '999999',
            total: contador?.sin_asignar ?? 0
        };
        const contadorDescartadas = {
            id_estado: 'descartadas',
            nombre: 'Descartadas',
            color: 'd32f2f',
            total: contador?.descartadas ?? 0
        };

        const indiceValidado = estados.findIndex((estado) =>
            Number(estado.id_estado) === 4 || estado.nombre?.toLowerCase() === 'validado'
        );

        if (indiceValidado === -1) {
            return [...estados, contadorSinAsignar, contadorDescartadas];
        }

        return [
            ...estados.slice(0, indiceValidado + 1),
            contadorSinAsignar,
            ...estados.slice(indiceValidado + 1),
            contadorDescartadas
        ];
    };

    const calcularResumenTareasGlobal = (proyectos = [], estados = []) => {
        const resumen = crearContadorVacio(estados);

        proyectos.forEach((proyecto) => {
            const contador = proyecto.contadores_tareas;

            if (!contador) return;

            resumen.total += Number(contador.total || 0);
            resumen.sin_asignar += Number(contador.sin_asignar || 0);
            resumen.descartadas += Number(contador.descartadas || 0);

            contador.estados?.forEach((estadoProyecto) => {
                const idEstado = Number(estadoProyecto.id_estado);
                const estadoResumen = resumen.estados.find(
                    (estado) => Number(estado.id_estado) === idEstado
                );

                if (estadoResumen) {
                    estadoResumen.total += Number(estadoProyecto.total || 0);
                } else {
                    resumen.estados.push({
                        id_estado: idEstado,
                        nombre: estadoProyecto.nombre,
                        color: estadoProyecto.color,
                        total: Number(estadoProyecto.total || 0)
                    });
                }
            });
        });

        return resumen;
    };

    const crearContadorVacio = (estados = []) => ({
        total: 0,
        sin_asignar: 0,
        descartadas: 0,
        estados: estados.map((estado) => ({
            id_estado: Number(estado.id ?? estado.id_estado),
            nombre: estado.nombre,
            color: estado.color,
            total: 0
        }))
    });

    const normalizarContadoresProyectos = (responseContadores) => {
        const raw = responseContadores?.data || {};
        const estados = responseContadores?.estados || [];
        const contadores = {};

        const asegurarProyecto = (idProyecto) => {
            const key = String(idProyecto);
            if (!contadores[key]) {
                contadores[key] = crearContadorVacio(estados);
            }
            return contadores[key];
        };

        if (Array.isArray(raw)) {
            raw.forEach((item, index) => {
                if (!item) return;

                if (item.id_proyecto !== undefined && item.id_estado !== undefined) {
                    const contador = asegurarProyecto(item.id_proyecto);
                    const idEstado = Number(item.id_estado);
                    const total = Number(item.total || 0);
                    contador.total += total;

                    const estadoExistente = contador.estados.find((estado) => Number(estado.id_estado) === idEstado);
                    if (estadoExistente) {
                        estadoExistente.total = total;
                    } else {
                        contador.estados.push({
                            id_estado: idEstado,
                            nombre: item.nombre || item.estado_nombre || `Estado ${idEstado}`,
                            color: item.color || item.estado_color || '999999',
                            total
                        });
                    }
                    return;
                }

                if (item.estados) {
                    const key = String(item.id_proyecto ?? item.id ?? index);
                    contadores[key] = item;
                }
            });

            return contadores;
        }

        Object.entries(raw).forEach(([idProyecto, contador]) => {
            contadores[String(idProyecto)] = contador;
        });

        return contadores;
    };

    const cargarOpcionesAdm = async () => {
        try {
            const response = await getOpcionesProyectos();
            setOpciones(response.data.opcionesproyectos);
            setOpcionesDialog(response.data.opcionesdialogproyectos);
            setOpcionesEdit(response.data.opcionesEdit);

        } catch (error) {
            console.error("Error al añadir el cliente:", error);

        }
    };
    const cargarOpciones = async (oculto) => {
        try {
            setLoaded(false);

            const responseSesion = await verificarToken();
            const rolActual = responseSesion?.rol || null;
            const mostrarDatosProyecto = String(rolActual) === '986';

            setRolUsuario(rolActual);

            const [
                responseListado,
                responseActivos,
                responseOcultos,
                responseContadores
            ] = await Promise.all([
                getProyectos(oculto),
                mostrarDatosProyecto ? getProyectos(0) : Promise.resolve({ data: [] }),
                mostrarDatosProyecto ? getProyectos(1) : Promise.resolve({ data: [] }),
                mostrarDatosProyecto ? getContadoresTareasProyectos(1) : Promise.resolve(null)
            ]);

            const estadosContadores = responseContadores?.estados || [];
            const contadores = mostrarDatosProyecto
                ? normalizarContadoresProyectos(responseContadores)
                : {};

            const inyectarContadores = (proyectos = []) => {
                return proyectos.map((proyecto) => ({
                    ...proyecto,
                    contadores_tareas: mostrarDatosProyecto
                        ? contadores[String(proyecto.id)] || crearContadorVacio(estadosContadores)
                        : null
                }));
            };

            const proyectosConContadores = ordenarPorCampoTexto(inyectarContadores(responseListado.data), 'nombre');
            const proyectosActivosConContadores = ordenarPorCampoTexto(inyectarContadores(responseActivos.data), 'nombre');
            const proyectosOcultosConContadores = ordenarPorCampoTexto(inyectarContadores(responseOcultos.data), 'nombre');

            const todosLosProyectos = [
                ...proyectosActivosConContadores,
                ...proyectosOcultosConContadores
            ];

            setProyecto(proyectosConContadores);
            setProyectosCopia(proyectosConContadores);
            setResumenProyectos({
                activos: proyectosActivosConContadores.length,
                ocultos: proyectosOcultosConContadores.filter((proyecto) => Number(proyecto.oculto) === 1).length
            });

            if (mostrarDatosProyecto) {
                setResumenTareasGlobal(
                    calcularResumenTareasGlobal(todosLosProyectos, estadosContadores)
                );
            } else {
                setResumenTareasGlobal(null);
            }

            setLoaded(true);
        } catch (error) {
            console.error("Error al cargar los proyectos:", error);
            setLoaded(true);
        }
    };

    const cargarClientes = async () => {
        try {
            const response = await getClientes();

            if (response.success) {
                setClientes(response.data);
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }



    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                // setOpenEdit(true);
                setOpen(!open);

                // Lógica para la opción 1
                break;

            case 2:
                openEdit ? setOpenEdit(false) : setOpenEdit(true);
                cargarOpciones(openEdit ? 0 : 1);

                break;

            default:
                console.log("Lógica para una opción desconocida");
                // Lógica para una opción desconocida
                break;
        }
    }

    const buscarPy = (event) => {
        const searchTerm = event.target.value.toLowerCase();

        if (searchTerm === "") {
            // Si el campo de búsqueda está vacío, puedes restaurar la lista original
            // Por ejemplo:
            setProyecto(proyectosCopia);
            return;
        }

        const resultados = proyectosCopia.filter(proyecto => {
            const clienteProyecto = clientes.find(cliente => String(cliente.id) === String(proyecto.id_cliente));

            return (
                proyecto.nombre?.toLowerCase().includes(searchTerm) ||
                proyecto.descripcion?.toLowerCase().includes(searchTerm) ||
                proyecto.correos_cliente?.toLowerCase().includes(searchTerm) ||
                clienteProyecto?.mail?.toLowerCase().includes(searchTerm) ||
                clienteProyecto?.correo?.toLowerCase().includes(searchTerm)
            );
        });

        // Actualiza el estado con los resultados
        // Por ejemplo:
        setProyecto(resultados);
        console.log("Resultados de búsqueda:", resultados);
    }


    useEffect(() => {
        cargarOpciones(0);
        cargarOpcionesAdm();
        cargarClientes();
    }, []);

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            xs={12}
            className='menu-back fade-in2'
        >
            <SubHeader titulo={'Proyectos'} />


            {opciones && (
                <OpcionesMenuFunc opciones={opciones} handleEvent={handleEvent}></OpcionesMenuFunc>
            )}
            {String(rolUsuario) === '986' && (
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={10.2}
                    gap={1}
                    sx={{
                        mt: 2,
                        p: 1.5,
                        border: '1px solid #e0e0e0',
                        borderRadius: 2,
                    }}
                >
                    <Grid
                        item
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            border: '1px solid #d0d0d0',
                            borderRadius: 1,
                            px: 1.5,
                            py: 0.75,
                            backgroundColor: '#fff',
                            minWidth: 180
                        }}
                    >
                        <Typography variant="caption" sx={{ fontWeight: 800 }}>
                            Proyectos activos: {resumenProyectos.activos}
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            border: '1px solid #d0d0d0',
                            borderRadius: 1,
                            px: 1.5,
                            py: 0.75,
                            backgroundColor: '#fff',
                            minWidth: 180
                        }}
                    >
                        <Typography variant="caption" sx={{ fontWeight: 800 }}>
                            Proyectos ocultos: {resumenProyectos.ocultos}
                        </Typography>
                    </Grid>
                </Grid>
            )}
            {String(rolUsuario) === '986' && resumenTareasGlobal && (
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={10.2}
                    gap={1}
                    sx={{
                        mt: 2,
                        p: 1.5,
                        border: '1px solid #e0e0e0',
                        borderRadius: 2,
                    }}
                >
                    <Grid
                        item
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid #d0d0d0',
                            borderRadius: 1,
                            px: 1.5,
                            py: 0.75,
                            backgroundColor: '#fff',
                            minWidth: 145
                        }}
                    >
                        <Typography variant="caption" sx={{ fontWeight: 800 }}>
                            Tareas totales: {resumenTareasGlobal.total ?? 0}
                        </Typography>
                    </Grid>

                    {estadosConSinAsignarGlobal(resumenTareasGlobal).map((estado) => (
                        <Grid
                            item
                            key={estado.id_estado}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                border: '1px solid #d0d0d0',
                                borderRadius: 1,
                                px: 1.5,
                                py: 0.75,
                                backgroundColor: '#fff',
                                minWidth: 130
                            }}
                        >
                            <Grid item sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <span
                                    style={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: '50%',
                                        backgroundColor: colorEstado(estado.color),
                                        display: 'inline-block',
                                        flexShrink: 0,
                                        marginRight: 6
                                    }}
                                />
                                <Typography
                                    variant="caption"
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {nombreEstadoResumen(estado.nombre)}
                                </Typography>
                            </Grid>

                            <Typography variant="caption" sx={{ fontWeight: 800, ml: 1 }}>
                                {estado.total}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            )}
            {
                !loaded && (
                    <CircularProgress />
                )
            }
            {/* <div className='menu-principal fade-in-2'> */}
            <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="start"
                xs={10.2}
                sx={{ mt: 2 }}
            >
                <TextField id="outlined-basic" label="Buscar..." name='search' variant="standard" sx={{ minWidth: '100%' }} onChange={(event) => buscarPy(event)} />

            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                xs={12}
                gap={2}
                sx={{ mt: 4 }}
            >
                {loaded && proyectos.length > 0 && (
                    proyectos.map(opcion => (
                        <ProyectoCard key={opcion.id} data={opcion} openEdit={openEdit} opciones={opcionesEdit} cargarOpciones={cargarOpciones} cargarOpcionesAdm={cargarOpcionesAdm} clientes={clientes} rolUsuario={rolUsuario} />
                    ))
                )}
            </Grid>
            {/* </div> */}
            {open && (
                <FormCrearProyecto
                    open={open}
                    setOpen={setOpen}
                    cargarProyectos={cargarOpciones}
                    opciones={opcionesDialog}
                    setOpciones={setOpcionesDialog}
                />
            )}

        </Grid>



    )
}
